export const PAYMENT_AMOUNT_OPTION = {
  FULL_PAYMENT: {
    name: 'fullPayment',
    value: 1
  },
  PARTIAL_PAYMENT: {
    name: 'partialPayment',
    value: 2
  }
};

export const MINIMUM_PAYMENT_AMOUNT_TYPE = {
  AMOUNT: 1,
  PERCENTAGE: 2
};

export const PAYMENT_PROCESSOR_TYPE = {
  PAYPAL: 4,
  TOUCHNET: 6,
  AUTHORIZE_DOT_NET: 9,
  OGONE: 13,
  CYBERSOURCE_SECURE_ACCEPTANCE: 14,
  CPS: 17,
  WPM: 19
};

export const AUTOMATIC_REFUND_OPTIONS = {
  CREDIT_CARD: 'creditCard',
  PAYMENT_CREDIT: 'paymentCredit'
};
